import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'

import { WarningBanner, WarningContent, WarningText } from './styled'

interface FormWarningAlertProps {
  message: React.ReactNode
  className?: string
}

export const FormWarningAlert: React.FC<FormWarningAlertProps> = ({
  message,
  className,
}) => (
  <WarningBanner className={className}>
    <FontAwesomeIcon icon={faTriangleExclamation} aria-hidden />
    <WarningContent>
      <WarningText>{message}</WarningText>
    </WarningContent>
  </WarningBanner>
)

export default FormWarningAlert
